<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>SERVIDOR SMTP</h3>
      </div>
      <div class="box-content">
        <p>
          Configure o servidor SMTP para envio de e-mails.
        </p>
        <form>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Remetente</label>
              <input class="input" type="text" v-model="newSmtp.email_send" />
            </div>
            <div class="item flex-1">
              <label>Nome do Remetente</label>
              <input class="input" type="text" v-model="newSmtp.email_send_name" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Servidor</label>
              <input class="input" type="text" v-model="newSmtp.host" />
            </div>
            <div class="item flex-1">
              <label>Porta</label>
              <input class="input" type="text" v-model="newSmtp.port" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class=" flex-1">
              <label>Usuário</label>
              <input class="input" type="text" v-model="newSmtp.user" />
            </div>

            <div class="item flex-1">
              <label>Senha</label>
              <input class="input" type="text" v-model="newSmtp.password" />
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class="">
              <div class="button primary" @click="saveSMTP()">
                Salvar
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  saveIntegration,
  getIntegrations,
} from "@/services/integration";


export default {
  name: "Email",
  data() {
    return {
      newSmtp: {
        email_send: '',
        email_send_name: '',
        host: '',
        port: '',
        user: '',
        password: '',
      }
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    this.getIntegrations();
  },
  methods: {
    saveSMTP() {
      let data = {
        email_send: this.newSmtp.email_send,
        email_send_name: this.newSmtp.email_send_name,
        host: this.newSmtp.host,
        port: this.newSmtp.port,
        user: this.newSmtp.user,
        password: this.newSmtp.password,
      };

      if (!data.host || !data.port || !data.user || !data.password || !data.email_send) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar a integração!",
        });
      }

      let params = {
        smtp: data
      };

      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Integração salva com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar integração",
          });
        });
    },
    getIntegrations() {
      getIntegrations()
        .then((result) => {
          this.newSmtp = result.smtp;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar integrações",
          });
        });
    },

  },
};
</script>
